const routes = {
  HomePage: '/',
  Overview: '/overview',
  ProfilePage: '/settings/profile',
  SettingsPage: '/settings',
  CorbeillePage: '/corbeille',
  DeepAnalysisPage: 'deepanalysis',
  EmployeesPage: '/dataextractor/employees',
  DataExplorerPage: '/dashboards/explorer',
  DataExtractorEmployeesPage: (employeeId) => `/dataextractor/employees/${employeeId}`,
  DashboardEditPage: '/dashboards/edit',
  TemplatesPage: '/dashboards/templates',
  AddGraphPage: (dashboardId) => `/dashboards/edit/${dashboardId}/add-graph`,
  GraphEditPage: (dashboardId, graphId) => `/dashboards/edit/${dashboardId}/${graphId}`,
  DashboardExplorerPage: `/dashboards/explorer`,
  DashboardEditByIdPage: (dashboardId) => `/dashboards/edit/${dashboardId}`,
  LibraryPage: '/library',
  TemplateCategoryPage: (dashboardId) => `/dashboards/templates/${dashboardId}`,
  PeopleHubPage: '/people-hub',
  DataExtractorPayPage: '/dataextractor/pay',
  DataExtractorOrganizationPage: '/dataextractor/organization',
  AdvanceDeepAnalysisPage: '/advancedanalytics/deepanalysis',
  AdvancedAnalyticsPage: '/advancedanalytics',
  DashboardsSharedWithMePage: '/dashboards/sharedwithme',
  MyDashboardPage: '/mydashboards',
  DataQualityPage: '/data-quality',
  DataLexiconPage: '/data-lexicon',
  FinancialHypothesesPage: '/financial-hypotheses',
  ForgotPasswordPage: '/login/ForgotPassword',
  SetPasswordPage: '/setPassword',
  LoginPage: '/login',
  SSOLoginPage: '/login/sso',
  GoogleCallbackPage: '/auth/google/callback',
  MicrosoftSSOLoginPage: '/login/sso/microsoft',
  MicrosoftCallbackPage: '/auth/microsoft/callback',
  LegalHubPage: '/legal-hub',
  BDESEViewPage: (reportId = ':reportId') => `/legal-hub/bdese/${reportId}`,
  ViewDomainPage: (domainId) => `/settings/domains/view/${domainId}`,
  UpdateDomainPage: (domainId) => `/settings/update-domain/${domainId}`,
  CreateDomainPage: '/settings/create-domain',
  DashboardExportPage: (dashboardId) => `/dashboards/export/edit/${dashboardId}`,
  IndexEgaliteHFPage: (reportId = ':reportId') => `/legal-hub/index-egalite-hf/${reportId}`,
  MappingAndNormalization: '/mapping-and-normalization',
  ExchangeRatesPage: '/exchange-rates',
  CalendarPage: '/calendar',
  ExclusionRulesPage: '/exclusion-rules',
  PayrollLineGroupsPage: '/regroupements',
  ImportsPage: '/imports',
  RemunerationPage: '/remuneration',
  PayrollForecastsPage: '/payroll-forecasts',
  PayrollForecastDetailPage: (forecastId = ':forecastId', tab = undefined) => {
    if (tab === ':tab?') return `/payroll-forecasts/${forecastId}/:tab?`;
    if (tab) return `/payroll-forecasts/${forecastId}/${tab}`;
    return `/payroll-forecasts/${forecastId}`;
  },
  PayrollForecastDetailsPage: (forecastId = ':forecastId', tab = ':tab') =>
    `/payroll-forecasts/${forecastId}/details/${tab}`,
};
export default routes;
